import * as datasources from "./datasources"
import * as plus from "./plus"

export default {
  ...datasources,
  ...plus,
}
